import {
  getInboxIconByType,
  INBOX_TYPES,
  TWILIO_CHANNEL_MEDIUM,
} from 'dashboard/helper/inbox';

export const CHANNEL_FILTERS = [
  {
    id: 'all',
    icon: 'i-lucide-inbox',
    labelKey: 'ESSENTIAL.CHANNELS.ALL',
    iconClass: 'text-n-blue-11',
    activeClass: 'border-n-blue-8 bg-n-blue-3 text-n-blue-12',
    inactiveClass:
      'border-n-blue-4 text-n-blue-11 hover:bg-n-blue-2 hover:border-n-blue-6',
    countClass: 'bg-n-blue-4 text-n-blue-11',
    iconContainerClass: 'bg-n-blue-3',
    tagClass: 'bg-n-blue-3 text-n-blue-11',
  },
  {
    id: 'whatsapp',
    icon: 'i-ri-whatsapp-fill',
    labelKey: 'ESSENTIAL.CHANNELS.WHATSAPP',
    iconClass: 'text-n-teal-11',
    activeClass: 'border-n-teal-8 bg-n-teal-3 text-n-teal-12',
    inactiveClass:
      'border-n-teal-4 text-n-teal-11 hover:bg-n-teal-2 hover:border-n-teal-6',
    countClass: 'bg-n-teal-4 text-n-teal-11',
    iconContainerClass: 'bg-n-teal-3',
    tagClass: 'bg-n-teal-3 text-n-teal-11',
  },
  {
    id: 'telegram',
    icon: 'i-ri-telegram-fill',
    labelKey: 'ESSENTIAL.CHANNELS.TELEGRAM',
    iconClass: 'text-n-blue-11',
    activeClass: 'border-n-blue-8 bg-n-blue-3 text-n-blue-12',
    inactiveClass:
      'border-n-blue-4 text-n-blue-11 hover:bg-n-blue-2 hover:border-n-blue-6',
    countClass: 'bg-n-blue-4 text-n-blue-11',
    iconContainerClass: 'bg-n-blue-3',
    tagClass: 'bg-n-blue-3 text-n-blue-11',
  },
  {
    id: 'email',
    icon: 'i-ri-mail-fill',
    labelKey: 'ESSENTIAL.CHANNELS.EMAIL',
    iconClass: 'text-n-ruby-11',
    activeClass: 'border-n-ruby-8 bg-n-ruby-3 text-n-ruby-12',
    inactiveClass:
      'border-n-ruby-4 text-n-ruby-11 hover:bg-n-ruby-2 hover:border-n-ruby-6',
    countClass: 'bg-n-ruby-4 text-n-ruby-11',
    iconContainerClass: 'bg-n-ruby-3',
    tagClass: 'bg-n-ruby-3 text-n-ruby-11',
  },
  {
    id: 'site',
    icon: 'i-ri-global-fill',
    labelKey: 'ESSENTIAL.CHANNELS.SITE',
    iconClass: 'text-n-iris-11',
    activeClass: 'border-n-iris-8 bg-n-iris-3 text-n-iris-12',
    inactiveClass:
      'border-n-iris-4 text-n-iris-11 hover:bg-n-iris-2 hover:border-n-iris-6',
    countClass: 'bg-n-iris-4 text-n-iris-11',
    iconContainerClass: 'bg-n-iris-3',
    tagClass: 'bg-n-iris-3 text-n-iris-11',
  },
];

const OTHER_CHANNEL_PRESENTATION = {
  icon: 'i-ri-cloudy-fill',
  labelKey: 'ESSENTIAL.CHANNELS.OTHER',
  iconClass: 'text-n-slate-11',
  activeClass: 'border-n-slate-8 bg-n-slate-3 text-n-slate-12',
  inactiveClass:
    'border-n-weak text-n-slate-11 hover:text-n-slate-12 hover:bg-n-alpha-2',
  countClass: 'bg-n-slate-4 text-n-slate-11',
  iconContainerClass: 'bg-n-slate-3',
  tagClass: 'bg-n-slate-3 text-n-slate-11',
};

export const INBOX_FILTER_PREFIX = 'inbox:';

export const inboxFilterId = inboxId => `${INBOX_FILTER_PREFIX}${inboxId}`;

export const inboxIdFromChannelFilter = filterId => {
  if (!String(filterId || '').startsWith(INBOX_FILTER_PREFIX)) return undefined;

  const inboxId = Number(String(filterId).replace(INBOX_FILTER_PREFIX, ''));
  return Number.isFinite(inboxId) && inboxId > 0 ? inboxId : undefined;
};

export const inboxSearchText = inbox => {
  const values = [
    inbox?.name,
    inbox?.channel_type,
    inbox?.medium,
    inbox?.provider,
    inbox?.provider_config?.provider,
    inbox?.additional_attributes?.provider,
    inbox?.additional_attributes?.integration,
    inbox?.additional_attributes?.medium,
    inbox?.additional_attributes?.channel,
    inbox?.additional_attributes?.channel_type,
    inbox?.additional_attributes?.source,
  ];

  return values.filter(Boolean).join(' ').toLowerCase();
};

export const isEvolutionInbox = inbox =>
  inboxSearchText(inbox).includes('evolution');

export const isWhatsappCloudInbox = inbox =>
  inbox?.channel_type === INBOX_TYPES.WHATSAPP &&
  inbox?.provider === 'whatsapp_cloud';

const isWhatsappInbox = inbox => {
  return (
    inbox?.channel_type === INBOX_TYPES.WHATSAPP ||
    (inbox?.channel_type === INBOX_TYPES.TWILIO &&
      inbox?.medium === TWILIO_CHANNEL_MEDIUM.WHATSAPP) ||
    isEvolutionInbox(inbox)
  );
};

export const channelBucketForInbox = inbox => {
  if (isWhatsappInbox(inbox)) return 'whatsapp';
  if (inbox?.channel_type === INBOX_TYPES.TELEGRAM) return 'telegram';
  if (inbox?.channel_type === INBOX_TYPES.EMAIL) return 'email';
  if (inbox?.channel_type === INBOX_TYPES.WEB) return 'site';
  return 'other';
};

export const channelLabelKeyForInbox = inbox => {
  if (isEvolutionInbox(inbox)) return 'ESSENTIAL.CHANNELS.WHATSAPP_EVOLUTION';
  if (isWhatsappCloudInbox(inbox)) {
    return 'ESSENTIAL.CHANNELS.WHATSAPP_API';
  }
  if (channelBucketForInbox(inbox) === 'whatsapp') {
    return 'ESSENTIAL.CHANNELS.WHATSAPP';
  }
  if (inbox?.channel_type === INBOX_TYPES.TELEGRAM) {
    return 'ESSENTIAL.CHANNELS.TELEGRAM';
  }
  if (inbox?.channel_type === INBOX_TYPES.EMAIL)
    return 'ESSENTIAL.CHANNELS.EMAIL';
  if (inbox?.channel_type === INBOX_TYPES.WEB) return 'ESSENTIAL.CHANNELS.SITE';
  return 'ESSENTIAL.CHANNELS.OTHER';
};

export const channelBadgeForInbox = inbox => {
  if (isEvolutionInbox(inbox)) return 'Evolution';
  if (isWhatsappCloudInbox(inbox)) return 'API';
  return '';
};

export const channelIconForInbox = inbox => {
  if (channelBucketForInbox(inbox) === 'whatsapp') return 'i-ri-whatsapp-fill';
  return getInboxIconByType(inbox?.channel_type, inbox?.medium, 'fill');
};

export const channelPresentationForBucket = bucket => {
  return (
    CHANNEL_FILTERS.find(filter => filter.id === bucket) ||
    OTHER_CHANNEL_PRESENTATION
  );
};

export const channelPresentationForInbox = inbox => {
  const bucket = channelBucketForInbox(inbox);
  return {
    ...channelPresentationForBucket(bucket),
    icon: channelIconForInbox(inbox),
    labelKey: channelLabelKeyForInbox(inbox),
    badge: channelBadgeForInbox(inbox),
  };
};

export const buildInboxChannelFilter = inbox => {
  const presentation = channelPresentationForInbox(inbox);

  return {
    ...presentation,
    id: inboxFilterId(inbox.id),
    inboxId: inbox.id,
    label: inbox.name,
  };
};

export const buildInboxChannelFilters = inboxes =>
  inboxes.filter(inbox => inbox?.id).map(buildInboxChannelFilter);

export const buildAvailableChannelFilters = inboxes => {
  const availableBuckets = new Set(inboxes.map(channelBucketForInbox));

  return CHANNEL_FILTERS.filter(
    filter => filter.id === 'all' || availableBuckets.has(filter.id)
  );
};

export const matchesChannelFilter = (inbox, filterId) => {
  const inboxId = inboxIdFromChannelFilter(filterId);

  if (inboxId !== undefined) return Number(inbox?.id) === inboxId;

  return filterId === 'all' || channelBucketForInbox(inbox) === filterId;
};

export const CHANNEL_HEALTH_STATUS = {
  OK: 'ok',
  WARNING: 'warning',
  ATTENTION: 'attention',
  UNKNOWN: 'unknown',
};

const hasValue = value => Boolean(String(value || '').trim());

const evolutionRiskText = inboxSearchTextValue => {
  if (
    /(connection closed|disconnected|logged out|qr|qrcode|invalid|lid)/i.test(
      inboxSearchTextValue
    )
  ) {
    return 'ESSENTIAL.CHANNEL_HEALTH.REASONS.EVOLUTION_NEEDS_ATTENTION';
  }
  return 'ESSENTIAL.CHANNEL_HEALTH.REASONS.EVOLUTION_CHECK_SESSION';
};

const attentionIfReauthorizationRequired = inbox => {
  if (!inbox?.reauthorization_required) return null;

  return {
    status: CHANNEL_HEALTH_STATUS.ATTENTION,
    reasonKey: 'ESSENTIAL.CHANNEL_HEALTH.REASONS.REAUTH_REQUIRED',
  };
};

const normalizedUrl = value => String(value || '').replace(/\/+$/, '');

const hasWebhookMismatch = healthData => {
  const expectedUrl = normalizedUrl(healthData?.expected_webhook_url);
  const configuredUrl = normalizedUrl(
    healthData?.webhook_configuration?.callback_url ||
      healthData?.webhook_configuration?.callback_uri ||
      healthData?.webhook_configuration?.url
  );

  return Boolean(expectedUrl && configuredUrl && expectedUrl !== configuredUrl);
};

const whatsappCloudHealth = healthEntry => {
  if (healthEntry?.state === 'loading') {
    return {
      status: CHANNEL_HEALTH_STATUS.UNKNOWN,
      reasonKey: 'ESSENTIAL.CHANNEL_HEALTH.REASONS.CLOUD_HEALTH_LOADING',
    };
  }

  if (healthEntry?.state === 'error') {
    return {
      status: CHANNEL_HEALTH_STATUS.ATTENTION,
      reasonKey: 'ESSENTIAL.CHANNEL_HEALTH.REASONS.CLOUD_HEALTH_UNAVAILABLE',
    };
  }

  const healthData = healthEntry?.data || healthEntry;
  if (!healthData || !Object.keys(healthData).length) return null;

  if (
    healthData.platform_type === 'NOT_APPLICABLE' ||
    healthData.throughput?.level === 'NOT_APPLICABLE'
  ) {
    return {
      status: CHANNEL_HEALTH_STATUS.WARNING,
      reasonKey:
        'ESSENTIAL.CHANNEL_HEALTH.REASONS.CLOUD_REGISTRATION_INCOMPLETE',
    };
  }

  if (
    healthData.code_verification_status &&
    healthData.code_verification_status !== 'VERIFIED'
  ) {
    return {
      status: CHANNEL_HEALTH_STATUS.ATTENTION,
      reasonKey: 'ESSENTIAL.CHANNEL_HEALTH.REASONS.CLOUD_PHONE_UNVERIFIED',
    };
  }

  if (['REJECTED', 'DECLINED'].includes(healthData.name_status)) {
    return {
      status: CHANNEL_HEALTH_STATUS.ATTENTION,
      reasonKey: 'ESSENTIAL.CHANNEL_HEALTH.REASONS.CLOUD_NAME_REJECTED',
    };
  }

  if (healthData.quality_rating === 'RED') {
    return {
      status: CHANNEL_HEALTH_STATUS.ATTENTION,
      reasonKey: 'ESSENTIAL.CHANNEL_HEALTH.REASONS.CLOUD_QUALITY_RED',
    };
  }

  if (healthData.quality_rating === 'YELLOW') {
    return {
      status: CHANNEL_HEALTH_STATUS.WARNING,
      reasonKey: 'ESSENTIAL.CHANNEL_HEALTH.REASONS.CLOUD_QUALITY_YELLOW',
    };
  }

  if (healthData.name_status === 'PENDING_REVIEW') {
    return {
      status: CHANNEL_HEALTH_STATUS.WARNING,
      reasonKey: 'ESSENTIAL.CHANNEL_HEALTH.REASONS.CLOUD_NAME_PENDING',
    };
  }

  if (hasWebhookMismatch(healthData)) {
    return {
      status: CHANNEL_HEALTH_STATUS.WARNING,
      reasonKey: 'ESSENTIAL.CHANNEL_HEALTH.REASONS.CLOUD_WEBHOOK_MISMATCH',
    };
  }

  return {
    status: CHANNEL_HEALTH_STATUS.OK,
    reasonKey: 'ESSENTIAL.CHANNEL_HEALTH.REASONS.CLOUD_READY',
  };
};

export const channelHealthForInbox = (inbox, healthEntry = null) => {
  const reauthorizationStatus = attentionIfReauthorizationRequired(inbox);
  if (reauthorizationStatus) return reauthorizationStatus;

  if (isWhatsappCloudInbox(inbox)) {
    const remoteHealth = whatsappCloudHealth(healthEntry);
    if (remoteHealth) return remoteHealth;
  }

  const channelBucket = channelBucketForInbox(inbox);

  if (isEvolutionInbox(inbox)) {
    const searchText = inboxSearchText(inbox);
    const hasKnownRisk =
      /(connection closed|disconnected|logged out|qr|qrcode|invalid|lid)/i.test(
        searchText
      );

    return {
      status: hasKnownRisk
        ? CHANNEL_HEALTH_STATUS.ATTENTION
        : CHANNEL_HEALTH_STATUS.UNKNOWN,
      reasonKey: evolutionRiskText(searchText),
    };
  }

  if (channelBucket === 'whatsapp') {
    if (!hasValue(inbox?.phone_number)) {
      return {
        status: CHANNEL_HEALTH_STATUS.WARNING,
        reasonKey: 'ESSENTIAL.CHANNEL_HEALTH.REASONS.MISSING_PHONE',
      };
    }

    return {
      status: CHANNEL_HEALTH_STATUS.OK,
      reasonKey: 'ESSENTIAL.CHANNEL_HEALTH.REASONS.WHATSAPP_READY',
    };
  }

  if (channelBucket === 'telegram') {
    if (!hasValue(inbox?.bot_name) || !hasValue(inbox?.webhook_url)) {
      return {
        status: CHANNEL_HEALTH_STATUS.WARNING,
        reasonKey: 'ESSENTIAL.CHANNEL_HEALTH.REASONS.TELEGRAM_CHECK_WEBHOOK',
      };
    }

    return {
      status: CHANNEL_HEALTH_STATUS.OK,
      reasonKey: 'ESSENTIAL.CHANNEL_HEALTH.REASONS.TELEGRAM_READY',
    };
  }

  if (channelBucket === 'email') {
    if (!hasValue(inbox?.email)) {
      return {
        status: CHANNEL_HEALTH_STATUS.WARNING,
        reasonKey: 'ESSENTIAL.CHANNEL_HEALTH.REASONS.EMAIL_CHECK_ADDRESS',
      };
    }

    return {
      status: CHANNEL_HEALTH_STATUS.OK,
      reasonKey: 'ESSENTIAL.CHANNEL_HEALTH.REASONS.EMAIL_READY',
    };
  }

  if (channelBucket === 'site') {
    if (!hasValue(inbox?.website_url)) {
      return {
        status: CHANNEL_HEALTH_STATUS.WARNING,
        reasonKey: 'ESSENTIAL.CHANNEL_HEALTH.REASONS.SITE_CHECK_URL',
      };
    }

    return {
      status: CHANNEL_HEALTH_STATUS.OK,
      reasonKey: 'ESSENTIAL.CHANNEL_HEALTH.REASONS.SITE_READY',
    };
  }

  return {
    status: CHANNEL_HEALTH_STATUS.UNKNOWN,
    reasonKey: 'ESSENTIAL.CHANNEL_HEALTH.REASONS.UNKNOWN',
  };
};
